
/**
 * Configurazione centralizzata delle rotte dell'applicazione
 */

export interface RouteConfig {
  path: string;
  isRoot?: boolean; // This property is optional in the interface
  title?: string;
}

export const ROUTES = {
  HOME: { path: '/', isRoot: true, title: 'Home' },
  HOME_ALIAS: { path: '/home', isRoot: true, title: 'Home' },
  // La pagina delle liste non deve più essere considerata root
  // per evitare che il tasto "indietro" chieda di uscire da ogni schermata
  LISTS: { path: '/lists', isRoot: false, title: 'Liste della Spesa' },
  SHOPPING: { path: '/shopping', isRoot: false, title: 'Spesa in Corso' },
  PRODUCTS: { path: '/products', isRoot: false, title: 'Prodotti' }, // Explicitly set isRoot to false
  CATEGORIES: { path: '/categories', isRoot: false, title: 'Categorie' }, // Explicitly set isRoot to false
  PROFILE: { path: '/profile', isRoot: false, title: 'Profilo' }, // Explicitly set isRoot to false
  SETTINGS: { path: '/settings', isRoot: false, title: 'Impostazioni' }, // Explicitly set isRoot to false
  RECURRING_PRODUCTS: { path: '/recurring-products', isRoot: false, title: 'Prodotti Ricorrenti' }, // Explicitly set isRoot to false
  SHOPS: { path: '/shops', isRoot: false, title: 'Negozi' }, // Explicitly set isRoot to false
  SHARED_LISTS: { path: '/shared-lists', isRoot: false, title: 'Liste Condivise' }, // Explicitly set isRoot to false
  SHOPPING_HISTORY: { path: '/shopping-history', isRoot: false, title: 'Cronologia Spesa' }, // Explicitly set isRoot to false
  PREMIUM: { path: '/premium', isRoot: false, title: 'Premium' }, // Explicitly set isRoot to false
  LOGIN: { path: '/login', isRoot: false, title: 'Accedi' }, // Explicitly set isRoot to false
  REGISTER: { path: '/register', isRoot: false, title: 'Registrati' }, // Explicitly set isRoot to false
  VERIFY_EMAIL: { path: '/verify-email', isRoot: false, title: 'Verifica Email' }, // Explicitly set isRoot to false
};

export const ROOT_PATHS = Object.values(ROUTES)
  .filter(route => route.isRoot)
  .map(route => route.path);

// Funzione di utilità per verificare se un percorso è una root
export const isRootPath = (path: string): boolean => {
  // Normalizza il percorso rimuovendo eventuali parametri di query e trailing slashes
  const normalizedPath = path.split('?')[0].replace(/\/+$/, '') || '/';
  return ROOT_PATHS.some(rootPath => 
    rootPath === normalizedPath || 
    rootPath === `/${normalizedPath}` || 
    `/${rootPath}` === normalizedPath
  );
};

// Funzione di utilità per ottenere il titolo della pagina
export const getRouteTitle = (path: string): string | undefined => {
  const normalizedPath = path.split('?')[0].replace(/\/+$/, '') || '/';
  const route = Object.values(ROUTES).find(
    r => r.path === normalizedPath || r.path === `/${normalizedPath}` || `/${r.path}` === normalizedPath
  );
  return route?.title;
};
